export default __webpack_public_path__ + "static/media/xamarin.63eaaa56.gif";